export var noData = function () { return ({
    isFetching: false,
    isReady: false,
    isError: false,
    data: undefined,
    errorMessage: undefined,
}); };
export var fetchingData = function () { return ({
    isFetching: true,
    isReady: false,
    isError: false,
    data: undefined,
    errorMessage: undefined,
}); };
export var readyData = function (rawData) { return ({
    isFetching: false,
    isReady: true,
    isError: false,
    data: rawData,
    errorMessage: undefined,
}); };
export var errorData = function (error) { return ({
    isFetching: false,
    isReady: false,
    isError: true,
    data: undefined,
    errorMessage: error,
}); };
